import * as React from 'react';

import CurrentOrgInjector from '~/apps/shared/containers/app/CurrentOrgInjector';
import SettingsSupport from '~/apps/shared/containers/settings/SettingsSupport';


export default function() {
  return (
    <CurrentOrgInjector
      component={SettingsSupport}
    />
  );
};
